export const locales = ["de"];
export const defaultLocale = "de";
export type ILocales = "de";
